import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DataStateChangeEvent, GridComponent, GridDataResult, PageChangeEvent, SelectionEvent } from '@progress/kendo-angular-grid';
import { GroupDescriptor, SortDescriptor, State, process } from '@progress/kendo-data-query';
import { sortBy } from 'sort-by-typescript';
import { AppCode } from 'src/app/app.code';
import Swal from 'sweetalert2';
import { EmailValidationModel } from '../../models/common-validation.model';
import { DepartmentConfigurationModel, DepartmentSetupModel, ValidationModel } from '../../models/department-setup.model';
import { AuthService } from '../../services/auth.service';
import { ClientService } from '../../services/client.service';
import { DepartmentSetupService } from '../../services/department-setup.service';

@Component({
  selector: 'app-department-setup',
  templateUrl: './department-setup.component.html',
  styleUrls: ['./department-setup.component.css']
})
export class DepartmentSetupComponent implements OnInit {
  [x: string]: any;
  @Input() public departmentConfiguration: DepartmentConfigurationModel = new DepartmentConfigurationModel();
  @Output() public returnSelectedDepartmentIds = new EventEmitter<any>();
  @Output() public returnSelectedServiceId = new EventEmitter<any>();
  state: State =
    {
      skip: 0,
      take: 20,
    }
  public sort: SortDescriptor[] = [];
  public gridView: GridDataResult;
  skip: number = 0;
  gridRowCount: number = 0;
  pageSize: number = 20;
  // departmentList : [];
  departmentSetupModel: DepartmentSetupModel = new DepartmentSetupModel();
  validationModel = new ValidationModel;
  isValidForm: boolean = null;
  loading: boolean = false;
  gridHeight: number = 640;
  addEditFormName: string = "Add Department";
  @ViewChild('departmentPanelAddEdit') departmentPanelAddEditRef: ElementRef;
  @ViewChild('departmentFormModalPopup') public departmentFormModalPopupRef: ElementRef;
  @ViewChild('panelGridModalPopupDepartment') panelGridModalPopupRef: ElementRef;
  @ViewChild('panelGridDepartment') public panelGridRef: ElementRef;
  showModal: any;
  btnName: string;
  departmentList = [];
  departmentList2 = [];
  emailValidationModel: any;
  serviceList: any = [];

  constructor(private clientService: ClientService, private departmentSetupService: DepartmentSetupService,
    private authService: AuthService,
    private appCode: AppCode, private renderer: Renderer2) {
    this.client = this.clientService.getClient();
    this.showModal = (!this.departmentConfiguration.addEditInModalPopUp) ? true : this.showModal;
    this.allData = this.allData.bind(this);
  }


  ngOnInit() {
    // Set Grid Height
    this.setGridHeight();

    // Clear Fields
    this.onClear();
    this.bindData();


    // Get Department List
    //this.getDepartmentList();
  }

  ngAfterViewInit() {
    if (this.departmentConfiguration.addEditInModalPopUp) {
      this.renderer.appendChild(this.departmentFormModalPopupRef.nativeElement, this.departmentPanelAddEditRef.nativeElement);
    }
    if (this.departmentConfiguration.selectDepartmentSection) {
      this.renderer.appendChild(this.panelGridModalPopupRef.nativeElement, this.panelGridRef.nativeElement);
    }
  }


  onResize() {
    this.setGridHeight();
  }
  setGridHeight() {
    var windowHeight = window.innerHeight;
    this.gridHeight = windowHeight - 230;
    this.gridRowCount = this.gridView != undefined ? this.gridView.total : 0;
    this.appCode.setPageHeight();
  }

  onClear() {
    //this.outpkTableId.emit("0");
    this.departmentConfiguration.selectedValueDepartmentDropDownList = [0, 0];
    this.returnSelectedDepartmentIds.emit(this.departmentConfiguration.selectedValueDepartmentDropDownList);

    this.departmentConfiguration.selectedValueServiceDropDownList = 0;
    this.returnSelectedServiceId.emit(this.departmentConfiguration.selectedValueServiceDropDownList);

    this.departmentSetupModel = new DepartmentSetupModel();
    this.addEditFormName = "Add Department";
    this.btnName = "SUBMIT";
    this.validationModel = new ValidationModel();
    this.emailValidationModel = new EmailValidationModel();

  }

  async onChangeEmail(newValue) {
    this.userNameValidationModel.isValid = true;
    this.emailValidationModel = await this.appCode.onEmailValidation(newValue, this.departmentConfiguration.requiredFields.email);
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
  }

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.getDepartmentList();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.departmentList, this.state);
  }
  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }
  // Bind All Data for excel Method
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.departmentList, {
      }).data,
    };
    return result;
  }

  openAddDepartment() {
    this.onClear();
    this.addEditFormName = this.departmentConfiguration.addFormName;
    this.scrollTo('panelAddEdit');
  }

  scrollTo(panelId: string) {
    this.appCode.scrollTo(panelId);
  }

  openAddEditInModlalPopup() {
    this.onClear();
    this.addEditFormName = this.departmentConfiguration.addFormName;
    if (this.departmentConfiguration.addEditInModalPopUp) {
      this.showModal = true;
    }
    else {
      this.appCode.scrollTo("panelAddEdit");
    }
  }

  closeSelectDepartmentModlalPopup() {
    this.selectDepartmentSectionShowModal = false;
    this.selectDepartmentSectionShowModalClass = "modal fade";
  }

  openSelectDepartmentModlalPopup() {
    this.selectDepartmentSectionShowModal = true;
    this.selectDepartmentSectionShowModalClass = "modal fade in";
  }

  selectionChange(event: any) {
    alert(event);
  }

  selectedRowChange(selectionEvent: SelectionEvent) {

    console.log(selectionEvent.selectedRows[0]);
    var res = selectionEvent.selectedRows[0].dataItem;
    this.departmentSetupModel = res;

    //this.departmentConfiguration.selectedValueDepartmentDropDownList[0] =
    //  (this.departmentSetupModel.parentDepartmentId == null ? this.departmentSetupModel.tblDepartmentId : this.departmentSetupModel.parentDepartmentId);
    //this.departmentConfiguration.selectedValueDepartmentDropDownList[1] =
    //  (this.departmentSetupModel.parentDepartmentId != null ? this.departmentSetupModel.tblDepartmentId : null);

    //this.returnSelectedDepartmentIds.emit(this.departmentConfiguration.selectedValueDepartmentDropDownList);

    //this.departmentConfiguration.selectedValueServiceDropDownList = this.departmentSetupModel;
    //this.returnSelectedServiceId.emit(this.departmentConfiguration.selectedValueServiceDropDownList);


    this.closeSelectDepartmentModlalPopup();
  }
  closeAddEditModlalPopup() {
    this.onClear();
    this.showModal = false;
  }
  closeAdddepartmentModlalPopup() {
    this.onClear();
    this.showModal = false;
  }
 
  async insertUpdateDepartmentData() {
    this.departmentSetupModel.clientId = this.client.clientId;
    this.departmentSetupModel.formId = this.departmentConfiguration.formId;
    this.departmentSetupModel.autoGenerateCode = this.departmentConfiguration.autoGenerateDepartmentCode;
    if (this.departmentSetupModel.tblDepartmentId == 0) {
      this.departmentSetupModel.createdBy = this.appCode.getCurrentUserName();
    }
    else {
      this.departmentSetupModel.updatedBy = this.appCode.getCurrentUserName();
    }

    var data = await this.departmentSetupService.postAddUpdateDepartment(this.departmentSetupModel);
    return data;
  }
  async bindData() {
    this.loading = true;
   
    if (this.departmentConfiguration.displayListCardView || this.departmentConfiguration.displayDepartmentDropDownList) {
      await this.getDepartmentList();
    
      if (!this.departmentConfiguration.displayDepartmentDropDownList) {
        this.gridView = process(this.departmentList, this.state);
        this.gridRowCount = this.gridView.total;
      }
      else {
        this.departmentList = this.departmentList.sort(sortBy('departmentName'));
      }
      this.loading = false;

    }
  }
  // Get All Department Details
  async getDepartmentList(parentDepartmentId: string = "0") {
    this.loading = true;
   
    var data = await this.departmentSetupService.getAllDepartment(parentDepartmentId); //.then(async (data: any) => {

    if (this.departmentConfiguration.displayListCardView) {
      this.departmentList = data;
      this.gridView = process(this.departmentList, this.state);
      this.gridRowCount = this.gridView.total;
    }
    else if (this.departmentConfiguration.displayDepartmentDropDownList) {
      if (parentDepartmentId == "0") {
        this.departmentList = data;
      } else {
        this.departmentList2 = [];
        this.departmentList2 = data;
      }
    }
    this.loading = false;    
  }

  // ACTION - EDIT - Department By ID
  onEdit(departmentId, type) {
    this.onClear();
    this.btnName = "UPDATE";
    this.addEditFormName = this.departmentConfiguration.editFormName;
    this.scrollTo('panelAddEdit');
    this.loading = true;
    this.departmentSetupService.getDepartmentByID(departmentId, type)
      .then((data: any) => {
        for (let res of data) {
          this.departmentSetupModel.tblDepartmentId = res.tblDepartmentId;
          this.departmentSetupModel.formId = res.formId;
          this.departmentSetupModel.parentDepartmentId = res.parentDepartmentId;
          this.departmentSetupModel.departmentCode = res.departmentCode;
          this.departmentSetupModel.departmentName = res.departmentName;
          this.departmentSetupModel.telephone = res.telephone;
          this.departmentSetupModel.email = res.email;
          this.departmentSetupModel.clientId = res.clientId;
          // this.departmentSetupModel.userId = res.userId;
          
          this.departmentSetupModel.tblDepartmentId = res.tblDepartmentId;
          this.departmentSetupModel.parentDepartmentId = res.parentDepartmentId;
          this.departmentConfiguration.selectedValueDepartmentDropDownList = res.tblDepartmentId;

          //this.departmentConfiguration.selectedValueDepartmentDropDownList[0] =
          //  (this.departmentSetupModel.parentDepartmentId == null ? this.departmentSetupModel.tblDepartmentId : this.departmentSetupModel.parentDepartmentId);
          //this.departmentConfiguration.selectedValueDepartmentDropDownList[1] =
          //  (this.departmentSetupModel.parentDepartmentId != null ? this.departmentSetupModel.tblDepartmentId : null);

          //this.returnSelectedDepartmentIds.emit(this.departmentConfiguration.selectedValueDepartmentDropDownList);
        }
        this.loading = false;
      }, (error) => {
        console.error("Error:   " + JSON.stringify(error));
        this.loading = false;
      });
  }

  // ACTION - DELETE
  onDelete(departmentId, type) {
    this.loading = true;
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this Department?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value === true) {
        this.departmentSetupService.getDepartmentByID(departmentId, type)
          .then(() => {
            // Get All Department Details
            this.getDepartmentList();
          }, (error) => {
            console.error("Error:   " + JSON.stringify(error));
            this.loading = false;
          });
      } else if (result.dismiss) {
        // Get All Department Details
        this.getDepartmentList();
      }
    });
  }


  // To Apply Validation Form
  async validateFormData() {

    if (this.departmentConfiguration.requiredFields.parentDepartment && (this.departmentSetupModel.parentDepartmentId == null || this.departmentSetupModel.parentDepartmentId == 0)) {
      this.validationModel.isParentDepartmentValid = false;
    }
    if (this.departmentConfiguration.requiredFields.departmentCode && !this.departmentConfiguration.autoGenerateDepartmentCode && this.departmentSetupModel.departmentCode == "") {
      this.validationModel.isDepartmentCodeValid = false;
      this.validationModel.departmentCodeValidationMessage = "Department Code is required.";
    }
    else {
      this.validationModel.isDepartmentCodeValid = true;
    }
    if (this.validationModel.isDepartmentCodeValid && !this.departmentConfiguration.autoGenerateDepartmentCode) {
      var checkdepartmentExists = this.departmentList.find(f => f.departmentCode.toLowerCase() == this.departmentSetupModel.departmentCode.toLowerCase());
      if (checkdepartmentExists && checkdepartmentExists.tblDepartmentId != this.departmentSetupModel.tblDepartmentId) {
        this.validationModel.isDepartmentCodeValid = false;
        this.validationModel.departmentCodeValidationMessage = "Department Code already exists.";
      }
      else {
        this.validationModel.isDepartmentCodeValid = true;
      }
    }

    this.validationModel.isDepartmentNameValid = this.departmentConfiguration.requiredFields.departmentName && this.departmentSetupModel.departmentName == "" ? false : true;
    this.validationModel.isTelephoneValid = this.departmentConfiguration.requiredFields.telephone && this.departmentSetupModel.telephone == "" ? false : true;

    this.emailValidationModel = await this.appCode.onEmailValidation(this.departmentSetupModel.email, this.departmentConfiguration.requiredFields.email);

    if (!this.validationModel.isDepartmentNameValid || !this.validationModel.isTelephoneValid || !this.emailValidationModel.isEmailIdValid

    ) {
      this.isValidForm = false;
      return await this.isValidForm;
    }
    else {
      this.isValidForm = true;
      return await this.isValidForm;
    }

  }

  // Submit Process
  async onSubmit() {
    this.loading = true;
    var result = await this.validateFormData();
    if (result != null && result != undefined) {
      if (result == true) {
        this.onSave();
      }
      else {
        this.loading = false;
      }
    }
    else {
      this.loading = false;
    }
  }

  async onSave() {
    var loginOptionChange = false;
    //if tblDepartmentId == 0 then new Department else Edit Department
    var tblDepartmentId = this.departmentSetupModel.tblDepartmentId;

    //insert/update department data
    var departmentId = await this.insertUpdateDepartmentData();

    this.departmentSetupModel.tblDepartmentId = parseInt(departmentId.toString());

    Swal.fire({
      text: (tblDepartmentId == 0 ? "Department Added Successfully" : "Department Updated Successfully"),
      confirmButtonText: 'Ok',
      confirmButtonColor: '#3085d6',
      allowOutsideClick: true
    }).then((result) => {
      this.onClear();
      if (result.value === true) {
        this.getDepartmentList();
        //this.onEdit(departmentId, 'DepartmentByID');
        this.loading = false;
        if (this.departmentConfiguration.addEditInModalPopUp) {
          //this.closeAddEditModlalPopup(); //ToDo
        }
      }
    });
  }
  onChangeTelephone(newValue: any, fieldName: string) {
    if (fieldName == "telephone2") {
      var data = this.appCode.validateFormatedText(newValue, this.departmentConfiguration.fieldsFormat.telephone1);
      this.departmentSetupModel.telephone = data;
    }
  }
  // Cancel
  onCancel() {
    this.onClear();
    this.scrollTo('panelGrid');
  }

  onDepartmentChange() {
    this.getDepartmentList(this.departmentConfiguration.selectedValueDepartmentDropDownList[0]);
    this.departmentConfiguration.selectedValueDepartmentDropDownList[1] = "0";
    this.returnSelectedDepartmentIds.emit(this.departmentConfiguration.selectedValueDepartmentDropDownList);
    this.bindServiceList();
  }
  onDepartmentChange2() {
    this.returnSelectedDepartmentIds.emit(this.departmentConfiguration.selectedValueDepartmentDropDownList);
    this.bindServiceList();
  }

  async bindServiceList() {    
    var data = await this.departmentSetupService.getServicesByDepartment(this.departmentConfiguration.selectedValueDepartmentDropDownList[0], this.departmentConfiguration.selectedValueDepartmentDropDownList[1]);
    this.serviceList = data;
  }

  onServiceChange() {
    this.returnSelectedServiceId.emit(this.departmentConfiguration.selectedValueServiceDropDownList);
  }

}
